<template>
  <div
    class="animated-text-by-word"
    ref="refRoot"
  >
    <div class="base"><slot /></div>
    <div
      class="animated"
      ref="refAnimated"
      :aria-hidden="true"
    >
      <SplitLines
        type="lines, words"
        @loaded="onLoaded"
      >
        <slot />
      </SplitLines>
    </div>
  </div>
</template>

<script setup lang="ts">
const props = defineProps({
  auto: {
    default: true,
  },
})

const emits = defineEmits(["loaded"])

const { $gsap, $ScrollTrigger } = useNuxtApp()

const { app, debug, browser } = useStores()

const refRoot = ref(null)
const refAnimated = ref(null)

const reset = function () {
  let timeline = $gsap.timeline()
  if (!refAnimated.value) return
  timeline.add("start")

  timeline.set(
    refAnimated.value.querySelectorAll(".word"),
    { y: 50, opacity: 0 },
    "start"
  )

  return timeline
}

const animateIn = function ({ tl, label, opts } = {}) {
  let timeline = $gsap.timeline({ ...opts })
  if (!refAnimated.value) return
  timeline.add("start")
  timeline.fromTo(
    refAnimated.value.querySelectorAll(".word"),
    {
      y: 50,
      opacity: 0,
    },
    {
      y: 0,
      opacity: 1,
      duration: 0.2,
      stagger: 0.05,
    },
    "start"
  )

  if (tl) {
    tl.add(timeline, label)
  }

  return timeline
}

const animateOut = function ({ tl, label, opts } = {}) {
  let timeline = $gsap.timeline({ ...opts })
  if (!refAnimated.value) return
  timeline.add("start")

  timeline.fromTo(
    refAnimated.value.querySelectorAll(".word"),
    {
      y: 0,
      opacity: 1,
    },
    {
      y: -50,
      opacity: 0,
      duration: 0.2,
      stagger: 0.05,
    },
    "start"
  )

  if (tl) {
    tl.add(timeline, label)
  }

  return timeline
}

const { init } = useScrollTrigger(() => {
  if (!props.auto) return

  let tl = $gsap.timeline({
    scrollTrigger: {
      trigger: refRoot.value,
      start: "top bottom",
      end: "top top",
      onEnter: animateIn,
      // markers: true,
      // onLeave: animateOut,
      // onEnterBack: animateIn,
      // onLeaveBack: animateOut,
    },
  })

  return tl
})

watch(() => [props.auto], init)

onMounted(() => {
  if (!props.auto) return
  reset()
})

// useResize2(() => {
//   reset()
//   animateIn()
// })

const onLoaded = function () {
  if (props.auto) {
    reset()
    init()
  }
  emits("loaded")
}

defineExpose({
  reset,
  animateIn,
  animateOut,
})
</script>

<style lang="scss" scoped>
@import "@/styles/shared.scss";

.animated-text-by-word {
  position: relative;
}

.base {
  opacity: 0;
}

.animated {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
}
</style>
